import {
  FETCH_PRODUCT_DIMENSION_PRESETS,
  CREATE_PRODUCT_DIMENSION_PRESETS,
  EDIT_PRODUCT_DIMENSION_PRESETS,
  DELETE_PRODUCT_DIMENSION_PRESETS
} from '../actions/types'

const productDimensionPresetsReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_PRODUCT_DIMENSION_PRESETS:
      return action.payload
    case CREATE_PRODUCT_DIMENSION_PRESETS:
      return [...state, action.payload]
    case EDIT_PRODUCT_DIMENSION_PRESETS:
      return state.map(preset => (preset.id === action.payload.id ? action.payload : preset))
    case DELETE_PRODUCT_DIMENSION_PRESETS:
      return state.filter(preset => preset.id !== action.payload.id)
    default:
      return state
  }
}

export default productDimensionPresetsReducer
